var map = {
	"./bg_bird.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_bird.png",
	"./bg_buffalo.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_buffalo.png",
	"./bg_cat.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_cat.png",
	"./bg_cow.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_cow.png",
	"./bg_dog.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_dog.png",
	"./bg_elephan01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_elephan01.png",
	"./bg_elephant.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_elephant.png",
	"./bg_goat.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_goat.png",
	"./bg_goat01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_goat01.png",
	"./bg_goat02.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_goat02.png",
	"./bg_hen.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_hen.png",
	"./bg_hen01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_hen01.png",
	"./bg_horse.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_horse.png",
	"./bg_horse01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_horse01.png",
	"./bg_khai.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_khai.png",
	"./bg_khai01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_khai01.png",
	"./bg_khai02.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_khai02.png",
	"./bg_khai03.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_khai03.png",
	"./bg_monkey.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_monkey.png",
	"./bg_monkey_fishing.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_monkey_fishing.png",
	"./bg_pigeon.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_pigeon.png",
	"./bg_sheep.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_sheep.png",
	"./bg_sheep01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_sheep01.png",
	"./bg_sparrow.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_sparrow.png",
	"./bg_sparrow01.png": "./src/EGRContent/Story/RayoKoSaag/images/bg_sparrow01.png",
	"./bullock-cart.gif": "./src/EGRContent/Story/RayoKoSaag/images/bullock-cart.gif",
	"./bullock-cart.png": "./src/EGRContent/Story/RayoKoSaag/images/bullock-cart.png",
	"./cock-crowing.gif": "./src/EGRContent/Story/RayoKoSaag/images/cock-crowing.gif",
	"./cock-crowing.png": "./src/EGRContent/Story/RayoKoSaag/images/cock-crowing.png",
	"./cock-wearing-chasma.gif": "./src/EGRContent/Story/RayoKoSaag/images/cock-wearing-chasma.gif",
	"./cock-wearing-chasma.png": "./src/EGRContent/Story/RayoKoSaag/images/cock-wearing-chasma.png",
	"./cover_banner.png": "./src/EGRContent/Story/RayoKoSaag/images/cover_banner.png",
	"./cover_page.png": "./src/EGRContent/Story/RayoKoSaag/images/cover_page.png",
	"./cow-in-cycle.gif": "./src/EGRContent/Story/RayoKoSaag/images/cow-in-cycle.gif",
	"./cow-in-cycle.png": "./src/EGRContent/Story/RayoKoSaag/images/cow-in-cycle.png",
	"./cow-mooing.gif": "./src/EGRContent/Story/RayoKoSaag/images/cow-mooing.gif",
	"./cow-mooing.png": "./src/EGRContent/Story/RayoKoSaag/images/cow-mooing.png",
	"./cow-with-cap.gif": "./src/EGRContent/Story/RayoKoSaag/images/cow-with-cap.gif",
	"./cow-with-cap.png": "./src/EGRContent/Story/RayoKoSaag/images/cow-with-cap.png",
	"./dancing-cock.gif": "./src/EGRContent/Story/RayoKoSaag/images/dancing-cock.gif",
	"./dancing-cock.png": "./src/EGRContent/Story/RayoKoSaag/images/dancing-cock.png",
	"./dog-barking.gif": "./src/EGRContent/Story/RayoKoSaag/images/dog-barking.gif",
	"./dog-barking.png": "./src/EGRContent/Story/RayoKoSaag/images/dog-barking.png",
	"./dog-itching.gif": "./src/EGRContent/Story/RayoKoSaag/images/dog-itching.gif",
	"./dog-itching.png": "./src/EGRContent/Story/RayoKoSaag/images/dog-itching.png",
	"./dog-with-headphones.gif": "./src/EGRContent/Story/RayoKoSaag/images/dog-with-headphones.gif",
	"./dog-with-headphones.png": "./src/EGRContent/Story/RayoKoSaag/images/dog-with-headphones.png",
	"./elephant-eating.gif": "./src/EGRContent/Story/RayoKoSaag/images/elephant-eating.gif",
	"./elephant-eating.png": "./src/EGRContent/Story/RayoKoSaag/images/elephant-eating.png",
	"./empty_plate.png": "./src/EGRContent/Story/RayoKoSaag/images/empty_plate.png",
	"./goat-bleating.gif": "./src/EGRContent/Story/RayoKoSaag/images/goat-bleating.gif",
	"./goat-bleating.png": "./src/EGRContent/Story/RayoKoSaag/images/goat-bleating.png",
	"./goat-breaking-open-a-pumpkin.gif": "./src/EGRContent/Story/RayoKoSaag/images/goat-breaking-open-a-pumpkin.gif",
	"./goat-breaking-open-a-pumpkin.png": "./src/EGRContent/Story/RayoKoSaag/images/goat-breaking-open-a-pumpkin.png",
	"./goat-eating-saag.gif": "./src/EGRContent/Story/RayoKoSaag/images/goat-eating-saag.gif",
	"./goat-eating-saag.png": "./src/EGRContent/Story/RayoKoSaag/images/goat-eating-saag.png",
	"./goat-finding-its-way.gif": "./src/EGRContent/Story/RayoKoSaag/images/goat-finding-its-way.gif",
	"./goat-finding-its-way.png": "./src/EGRContent/Story/RayoKoSaag/images/goat-finding-its-way.png",
	"./goat-in-leather-jacket.gif": "./src/EGRContent/Story/RayoKoSaag/images/goat-in-leather-jacket.gif",
	"./goat-in-leather-jacket.png": "./src/EGRContent/Story/RayoKoSaag/images/goat-in-leather-jacket.png",
	"./hatti-in-janti.gif": "./src/EGRContent/Story/RayoKoSaag/images/hatti-in-janti.gif",
	"./hatti-in-janti.png": "./src/EGRContent/Story/RayoKoSaag/images/hatti-in-janti.png",
	"./horse-neighing.gif": "./src/EGRContent/Story/RayoKoSaag/images/horse-neighing.gif",
	"./horse-neighing.png": "./src/EGRContent/Story/RayoKoSaag/images/horse-neighing.png",
	"./horse-playing-football.gif": "./src/EGRContent/Story/RayoKoSaag/images/horse-playing-football.gif",
	"./horse-playing-football.png": "./src/EGRContent/Story/RayoKoSaag/images/horse-playing-football.png",
	"./horse-playing-football1.gif": "./src/EGRContent/Story/RayoKoSaag/images/horse-playing-football1.gif",
	"./horse-with-mask.gif": "./src/EGRContent/Story/RayoKoSaag/images/horse-with-mask.gif",
	"./horse-with-mask.png": "./src/EGRContent/Story/RayoKoSaag/images/horse-with-mask.png",
	"./khai.gif": "./src/EGRContent/Story/RayoKoSaag/images/khai.gif",
	"./khai.png": "./src/EGRContent/Story/RayoKoSaag/images/khai.png",
	"./kitty-cat.gif": "./src/EGRContent/Story/RayoKoSaag/images/kitty-cat.gif",
	"./kitty-cat.png": "./src/EGRContent/Story/RayoKoSaag/images/kitty-cat.png",
	"./kitty-cat_zoom.gif": "./src/EGRContent/Story/RayoKoSaag/images/kitty-cat_zoom.gif",
	"./kitty-cat_zoom.png": "./src/EGRContent/Story/RayoKoSaag/images/kitty-cat_zoom.png",
	"./last_page.png": "./src/EGRContent/Story/RayoKoSaag/images/last_page.png",
	"./meowing-cat.gif": "./src/EGRContent/Story/RayoKoSaag/images/meowing-cat.gif",
	"./meowing-cat.png": "./src/EGRContent/Story/RayoKoSaag/images/meowing-cat.png",
	"./monkey-eating.gif": "./src/EGRContent/Story/RayoKoSaag/images/monkey-eating.gif",
	"./monkey-eating.png": "./src/EGRContent/Story/RayoKoSaag/images/monkey-eating.png",
	"./monkey-fishing.gif": "./src/EGRContent/Story/RayoKoSaag/images/monkey-fishing.gif",
	"./monkey-fishing.png": "./src/EGRContent/Story/RayoKoSaag/images/monkey-fishing.png",
	"./monkey-fishing_withbg.gif": "./src/EGRContent/Story/RayoKoSaag/images/monkey-fishing_withbg.gif",
	"./paada-eating.gif": "./src/EGRContent/Story/RayoKoSaag/images/paada-eating.gif",
	"./paada-eating.png": "./src/EGRContent/Story/RayoKoSaag/images/paada-eating.png",
	"./pigeon-eating-saag.gif": "./src/EGRContent/Story/RayoKoSaag/images/pigeon-eating-saag.gif",
	"./pigeon-eating-saag.png": "./src/EGRContent/Story/RayoKoSaag/images/pigeon-eating-saag.png",
	"./pigeon-flying.png": "./src/EGRContent/Story/RayoKoSaag/images/pigeon-flying.png",
	"./pigeon_fly.gif": "./src/EGRContent/Story/RayoKoSaag/images/pigeon_fly.gif",
	"./plate_with_rice.png": "./src/EGRContent/Story/RayoKoSaag/images/plate_with_rice.png",
	"./sheep-dancing.gif": "./src/EGRContent/Story/RayoKoSaag/images/sheep-dancing.gif",
	"./sheep-dancing.png": "./src/EGRContent/Story/RayoKoSaag/images/sheep-dancing.png",
	"./sheep-dancingnew.gif": "./src/EGRContent/Story/RayoKoSaag/images/sheep-dancingnew.gif",
	"./sheep-eating-rayo.gif": "./src/EGRContent/Story/RayoKoSaag/images/sheep-eating-rayo.gif",
	"./sheep-eating-rayo.png": "./src/EGRContent/Story/RayoKoSaag/images/sheep-eating-rayo.png",
	"./sparrow-chirping.gif": "./src/EGRContent/Story/RayoKoSaag/images/sparrow-chirping.gif",
	"./sparrow-chirping.png": "./src/EGRContent/Story/RayoKoSaag/images/sparrow-chirping.png",
	"./sparrow-eating-momo.gif": "./src/EGRContent/Story/RayoKoSaag/images/sparrow-eating-momo.gif",
	"./sparrow-eating-momo.png": "./src/EGRContent/Story/RayoKoSaag/images/sparrow-eating-momo.png",
	"./sparrow-with-kalli.gif": "./src/EGRContent/Story/RayoKoSaag/images/sparrow-with-kalli.gif",
	"./sparrow-with-kalli.png": "./src/EGRContent/Story/RayoKoSaag/images/sparrow-with-kalli.png",
	"./story-banner.svg": "./src/EGRContent/Story/RayoKoSaag/images/story-banner.svg",
	"./thaali.gif": "./src/EGRContent/Story/RayoKoSaag/images/thaali.gif",
	"./thaali.png": "./src/EGRContent/Story/RayoKoSaag/images/thaali.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/RayoKoSaag/images sync recursive ^\\.\\/.*$";